import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c42d554"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  colspan: "10",
  class: "containers"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "集装箱信息", -1))
const _hoisted_3 = { class: "container-no" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          prop: "Containers",
          "label-width": "0px",
          class: _normalizeClass(_ctx.showSealNumbers ? 'showSealNumbers' : '')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Containers, (item, i) => {
              return (_openBlock(), _createBlock(_component_miezz_card, {
                key: i,
                topButtons: i == 0 ? [] : [_ctx.btnDeleteContainer],
                onHandleHeaderButtonClick: 
            (arg1, arg2) => _ctx.handleDeleteContainer(i, arg2)
          
              }, {
                headerLeft: _withCtx(() => [
                  _createTextVNode(" 序号："),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(i + 1), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "集装箱箱型",
                    prop: `Containers[${i}].ContainerTypeId`,
                    rules: _ctx.rules.ContainerTypeId
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_select, {
                        modelValue: item.ContainerTypeId,
                        "onUpdate:modelValue": ($event: any) => ((item.ContainerTypeId) = $event),
                        label: item.ContainerTypeLabel,
                        "onUpdate:label": ($event: any) => ((item.ContainerTypeLabel) = $event),
                        options: _ctx._containerTypes,
                        onHandleChange: ($event: any) => (_ctx.handleChangeContainerTypeId(item))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onUpdate:label", "options", "onHandleChange"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"]),
                  _createVNode(_component_el_form_item, {
                    label: "数量",
                    prop: `Containers[${i}].Quantity`,
                    rules: _ctx.rules.Quantity
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: item.Quantity,
                        "onUpdate:modelValue": ($event: any) => ((item.Quantity) = $event),
                        min: 1,
                        disabled: _ctx.disabledQuantity
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "rules"]),
                  (item.Quantity && _ctx.showSealNumbers)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "箱封号",
                        prop: `Containers[${i}].SealNumbers`
                      }, {
                        default: _withCtx(() => [
                          (_ctx.departurePortContainer)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                style: {"color":"rgb(254, 153, 91)","text-decoration":"none"},
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.handleClickSealNumbers(item))
                              }, _toDisplayString((item.DeparturePortContainerSealNumbers?.length ?? 0) > 0
                  ? "查看详情"
                  : "暂无数据"), 9, _hoisted_4))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                style: {"color":"rgb(254, 153, 91)","text-decoration":"none"},
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.handleClickSealNumbers(item))
                              }, _toDisplayString((item.SealNumbers?.length ?? 0) > 0 ? "查看详情" : "暂无数据"), 9, _hoisted_5))
                        ]),
                        _: 2
                      }, 1032, ["prop"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["topButtons", "onHandleHeaderButtonClick"]))
            }), 128)),
            (!_ctx.disabledAdd)
              ? (_openBlock(), _createBlock(_component_miezz_card, {
                  key: 0,
                  class: "container-plus"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_button, {
                      model: _ctx.btnAddContainer,
                      onHandleClick: _ctx.handleClick
                    }, null, 8, ["model", "onHandleClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalSealNumbers,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalSealNumbers) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formSealNumbers,
          "label-width": "60px",
          ref: "ref-form-seal-numbers",
          class: "ref-form-seal-numbers"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choose?.Quantity, (i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createVNode(_component_el_form_item, {
                  label: `箱号${i}`,
                  prop: `Data[${i - 1}]`,
                  rules: _ctx.ruleSealNumbers.ContainerNo
                }, {
                  default: _withCtx(() => [
                    (_ctx.departurePortContainer)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.formSealNumbers.Data[i - 1].ContainerNo ?? "暂无数据"), 1))
                      : (_openBlock(), _createBlock(_component_miezz_input, {
                          key: 1,
                          modelValue: _ctx.formSealNumbers.Data[i - 1].ContainerNo,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.formSealNumbers.Data[i - 1].ContainerNo) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  ]),
                  _: 2
                }, 1032, ["label", "prop", "rules"]),
                _createVNode(_component_el_form_item, {
                  label: `封号${i}`,
                  prop: `Data[${i - 1}]`,
                  rules: _ctx.ruleSealNumbers.SealNo
                }, {
                  default: _withCtx(() => [
                    (_ctx.departurePortContainer)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.formSealNumbers.Data[i - 1].SealNo ?? "暂无数据"), 1))
                      : (_openBlock(), _createBlock(_component_miezz_input, {
                          key: 1,
                          modelValue: _ctx.formSealNumbers.Data[i - 1].SealNo,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.formSealNumbers.Data[i - 1].SealNo) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  ]),
                  _: 2
                }, 1032, ["label", "prop", "rules"])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}